import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import getAdditionalDataFrameMetadataModalContent from 'analysis-tool/data-frame-metadata/getDataFrameMetadataModalContent';
import {AdditionalDataFrameMetadataContents} from 'data-frames/modals/PersistedDataFrameMetadataModal';
import {PipelineStepStatusCode, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import ImmutableSet from 'util/ImmutableSet';

import {MAX_POPOVER_HEIGHT, MAX_POPOVER_WIDTH} from './PopoverConstants';

export const TABLE_CREATION_POPOVER_SUPPORTED_STEP_TYPES = new ImmutableSet([
  PipelineStepType.CONNECTION_DATA_DATASET,
  PipelineStepType.DATA_CATALOG_DATASET,
  PipelineStepType.INITIALIZE_DATASET,
  PipelineStepType.JOIN,
  PipelineStepType.NOTEBOOK_TABLE_DATASET,
  PipelineStepType.REGISTRY_SCHEMA_DATASET,
  PipelineStepType.UPLOAD_CSV_DATASET,
]);

export default function TableCreationPopoverContents({step}: {step: GetAnalysisPipelineStep}): JSX.Element {
  const dataFrame =
    step.statusCode === PipelineStepStatusCode.SUCCEEDED ? step.outputStepDatas[0].dataFrames[0] : null;

  return (
    <div className={css(styles.wrapper)}>
      {dataFrame && (
        <Row>
          <Col sm={12}>
            <FormGroup>
              <FieldLabel label="Name" />
              <p>{dataFrame.name}</p>
            </FormGroup>
          </Col>
        </Row>
      )}
      <AdditionalDataFrameMetadataContents {...getAdditionalDataFrameMetadataModalContent(step)} />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    padding: 14,
    margin: 2,
    width: MAX_POPOVER_WIDTH,
    maxHeight: MAX_POPOVER_HEIGHT,
  },
});
